// ==========================================================================
// TULIP HOME & KITCHEN - SHOPIFY ONLINE STORE 2.0 THEME ENGINE
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  initHeroSlider();
  initProductTabs();
  initShopifyCart();
  initSearch();
  initHeaderScroll();
  initMobileNav();
});

// --------------------------------------------------------------------------
// 1. HEADER SCROLL EFFECT
// --------------------------------------------------------------------------
function initHeaderScroll() {
  const header = document.querySelector(".header-wrapper");
  if (!header) return;
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (window.scrollY > 40) {
          header.classList.add("scrolled");
        } else {
          header.classList.remove("scrolled");
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}

// --------------------------------------------------------------------------
// 2. HERO BANNER SLIDER
// --------------------------------------------------------------------------
let currentSlide = 0;
let slideInterval = null;

function initHeroSlider() {
  const slides = document.querySelectorAll(".hero-slide");
  const dots = document.querySelectorAll(".slider-dot");
  const prevBtn = document.querySelector(".slider-arrow.prev");
  const nextBtn = document.querySelector(".slider-arrow.next");
  const container = document.querySelector(".hero-slider-section");

  if (!slides.length) return;

  function showSlide(index) {
    slides.forEach((s) => s.classList.remove("active"));
    dots.forEach((d) => d.classList.remove("active"));

    currentSlide = (index + slides.length) % slides.length;
    slides[currentSlide].classList.add("active");
    if (dots[currentSlide]) dots[currentSlide].classList.add("active");
  }

  function nextSlide() {
    showSlide(currentSlide + 1);
  }

  function prevSlide() {
    showSlide(currentSlide - 1);
  }

  if (nextBtn) nextBtn.addEventListener("click", nextSlide);
  if (prevBtn) prevBtn.addEventListener("click", prevSlide);

  dots.forEach((dot, idx) => {
    dot.addEventListener("click", () => showSlide(idx));
  });

  // Autoplay (starts after initial render to avoid main-thread contention)
  function startAutoplay() {
    if (slideInterval) clearInterval(slideInterval);
    slideInterval = setInterval(nextSlide, 6000);
  }

  function stopAutoplay() {
    if (slideInterval) clearInterval(slideInterval);
  }

  if (container) {
    container.addEventListener("mouseenter", stopAutoplay, { passive: true });
    container.addEventListener("mouseleave", startAutoplay, { passive: true });
  }

  setTimeout(startAutoplay, 3000);
}

// --------------------------------------------------------------------------
// 3. PRODUCT TABS (Native Liquid Panels)
// --------------------------------------------------------------------------
function initProductTabs() {
  const tabButtons = document.querySelectorAll(".tab-btn[data-tab-target]");
  if (!tabButtons.length) return;

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      tabButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const targetId = btn.getAttribute("data-tab-target");
      document.querySelectorAll(".tab-panel").forEach((panel) => {
        panel.style.display = "none";
        panel.classList.remove("active");
      });

      const targetPanel = document.querySelector(targetId);
      if (targetPanel) {
        targetPanel.style.display = "block";
        targetPanel.classList.add("active");
      }
    });
  });
}

// --------------------------------------------------------------------------
// 4. REAL SHOPIFY AJAX CART ENGINE
// --------------------------------------------------------------------------
function initShopifyCart() {
  const overlay = document.getElementById("cartOverlay");
  const drawer = document.getElementById("cartDrawer");
  const openBtn = document.getElementById("openCartBtn");
  const closeBtn = document.getElementById("closeCartBtn");

  if (openBtn) {
    openBtn.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
      fetchShopifyCart(false);
    });
  }

  if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);
  if (overlay) overlay.addEventListener("click", closeCartDrawer);

  // Intercept any classic product forms that might still submit
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (form && form.action && form.action.includes("/cart/add")) {
      e.preventDefault();
      handleAddToCartForm(form);
    }
  });
}

// Lightweight Direct Variant Add to Cart (bypasses 40 unnecessary form DOM elements)
window.addVariantToCart = function(variantId, btn) {
  if (!variantId) return;
  const originalHtml = btn ? btn.innerHTML : "";
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = `<span>Adding...</span>`;
  }

  const formData = new FormData();
  formData.append("id", variantId);
  formData.append("quantity", 1);

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
    headers: {
      "Accept": "application/json"
    }
  })
    .then((res) => {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    })
    .then(() => {
      fetchShopifyCart(true);
    })
    .catch((err) => {
      console.warn("AJAX add failed, submitting fallback:", err);
      window.location.href = `/cart/add?id=${variantId}&quantity=1`;
    })
    .finally(() => {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = originalHtml;
      }
    });
};

function openCartDrawer() {
  const overlay = document.getElementById("cartOverlay");
  const drawer = document.getElementById("cartDrawer");
  if (overlay) overlay.classList.add("active");
  if (drawer) drawer.classList.add("active");
  document.body.style.overflow = "hidden";
}

function closeCartDrawer() {
  const overlay = document.getElementById("cartOverlay");
  const drawer = document.getElementById("cartDrawer");
  if (overlay) overlay.classList.remove("active");
  if (drawer) drawer.classList.remove("active");
  document.body.style.overflow = "";
}

function handleAddToCartForm(form) {
  const submitBtn = form.querySelector('button[type="submit"]');
  const originalHtml = submitBtn ? submitBtn.innerHTML : "";
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.innerHTML = `<span>Adding...</span>`;
  }

  const formData = new FormData(form);

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
    headers: {
      "Accept": "application/json"
    }
  })
    .then((res) => {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    })
    .then(() => {
      // Fetch latest cart state and open drawer
      fetchShopifyCart(true);
    })
    .catch((err) => {
      console.warn("AJAX add failed, submitting normally:", err);
      form.submit();
    })
    .finally(() => {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHtml;
      }
    });
}

function fetchShopifyCart(openAfter) {
  fetch("/cart.js", {
    headers: {
      "Accept": "application/json"
    }
  })
    .then((res) => res.json())
    .then((cart) => {
      renderShopifyCart(cart);
      if (openAfter) {
        openCartDrawer();
      }
    })
    .catch((err) => {
      console.error("Failed to fetch Shopify cart:", err);
    });
}

function removeShopifyCartItem(itemKey) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0
    })
  })
    .then((res) => res.json())
    .then((cart) => {
      renderShopifyCart(cart);
    })
    .catch((err) => {
      console.error("Failed to remove item:", err);
    });
}

function updateShopifyCartItemQty(itemKey, qty) {
  if (qty < 0) qty = 0;
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: qty
    })
  })
    .then((res) => res.json())
    .then((cart) => {
      renderShopifyCart(cart);
    })
    .catch((err) => {
      console.error("Failed to update item quantity:", err);
    });
}

function renderShopifyCart(cart) {
  const itemsContainer = document.getElementById("cartItemsContainer");
  const countBadges = document.querySelectorAll(".cart-count-badge");
  const subtotalEl = document.getElementById("cartSubtotal");
  const shippingFill = document.getElementById("shippingProgressFill");
  const shippingText = document.getElementById("shippingProgressText");

  const itemCount = cart.item_count || 0;
  const totalPrice = cart.total_price ? (cart.total_price / 100).toFixed(2) : "0.00";

  // Update all header badges
  countBadges.forEach((b) => (b.textContent = itemCount));

  // Update subtotal
  if (subtotalEl) {
    subtotalEl.textContent = `$${totalPrice} CAD`;
  }

  // Shipping progress ($100 CAD threshold = 10000 cents)
  const freeThreshold = 10000;
  if (shippingFill && shippingText) {
    const rawTotal = cart.total_price || 0;
    if (rawTotal >= freeThreshold) {
      shippingFill.style.width = "100%";
      shippingText.innerHTML = "🎉 Congratulations! You unlocked <strong>FREE Canada-Wide Shipping</strong>!";
    } else {
      const remaining = ((freeThreshold - rawTotal) / 100).toFixed(2);
      const pct = Math.min(100, Math.round((rawTotal / freeThreshold) * 100));
      shippingFill.style.width = `${pct}%`;
      shippingText.innerHTML = `Add <strong>$${remaining} CAD</strong> more for <strong>FREE Canada-Wide Delivery</strong>!`;
    }
  }

  if (!itemsContainer) return;

  if (itemCount === 0 || !cart.items || cart.items.length === 0) {
    itemsContainer.innerHTML = `
      <div style="text-align: center; padding: 40px 10px; color: #64748b;">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-bottom: 12px; color: #cbd5e1;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        <p style="font-weight: 600; font-size: 16px; margin-bottom: 6px;">Your cart is empty</p>
        <p style="font-size: 13px;">Discover our authentic cookware and crystal collections!</p>
        <a href="/collections/all-products" class="btn-promo" style="display: inline-block; margin-top: 14px; font-size: 13px; padding: 8px 18px;">Start Shopping →</a>
      </div>
    `;
    return;
  }

  itemsContainer.innerHTML = cart.items
    .map((item) => {
      const imgUrl = item.featured_image && item.featured_image.url 
        ? item.featured_image.url 
        : (item.image || "https://cdn.shopify.com/s/files/1/0518/1397/4175/files/jzkequ_4181fc71-2517-44de-b9ec-8e8543edffa4.jpg");
      const priceStr = (item.final_price / 100).toFixed(2);
      const title = item.product_title || item.title;
      const variantTitle = item.variant_title && item.variant_title !== "Default Title" ? `<div style="font-size: 12px; color: #94a3b8;">${item.variant_title}</div>` : "";

      return `
        <div class="cart-item" data-key="${item.key}">
          <a href="${item.url}">
            <img src="${imgUrl}" alt="${title}" style="width: 70px; height: 70px; object-fit: contain; border-radius: 8px; border: 1px solid var(--color-border);" />
          </a>
          <div class="cart-item-details" style="flex: 1;">
            <a href="${item.url}" class="cart-item-title" style="font-weight: 600; font-size: 14px; color: var(--color-primary);">${title}</a>
            ${variantTitle}
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 8px;">
              <span class="cart-item-price" style="color: var(--color-gold); font-weight: 700;">$${priceStr} CAD</span>
              <div style="display: flex; align-items: center; gap: 8px;">
                <button type="button" onclick="updateShopifyCartItemQty('${item.key}', ${item.quantity - 1})" style="width: 24px; height: 24px; border: 1px solid var(--color-border); background: #fff; border-radius: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px;">-</button>
                <span style="font-size: 13px; font-weight: 600;">${item.quantity}</span>
                <button type="button" onclick="updateShopifyCartItemQty('${item.key}', ${item.quantity + 1})" style="width: 24px; height: 24px; border: 1px solid var(--color-border); background: #fff; border-radius: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 14px;">+</button>
                <button type="button" onclick="removeShopifyCartItem('${item.key}')" title="Remove" style="background: none; border: none; color: #ef4444; font-size: 16px; cursor: pointer; margin-left: 6px;">🗑️</button>
              </div>
            </div>
          </div>
        </div>
      `;
    })
    .join("");
}

// --------------------------------------------------------------------------
// 5. LIVE SEARCH
// --------------------------------------------------------------------------
function initSearch() {
  const searchInput = document.getElementById("headerSearchInput");
  const dropdown = document.getElementById("searchResultsDropdown");
  if (!searchInput || !dropdown) return;

  const searchForm = searchInput.closest("form");
  if (searchForm) {
    searchForm.addEventListener("submit", (e) => {
      const q = searchInput.value.trim();
      if (!q) {
        e.preventDefault();
      }
    });
  }

  searchInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      const q = searchInput.value.trim();
      if (q.length > 0) {
        window.location.href = `/search?q=${encodeURIComponent(q)}`;
      }
    }
  });

  let debounceTimer = null;

  searchInput.addEventListener("input", (e) => {
    const query = e.target.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      dropdown.style.display = "none";
      return;
    }

    debounceTimer = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`)
        .then((res) => {
          if (!res.ok) throw new Error("Search network error");
          return res.json();
        })
        .then((data) => {
          const prods = data.resources?.results?.products || [];
          if (prods.length === 0) {
            dropdown.innerHTML = `<div style="padding: 14px; font-size: 13px; color: #64748b; text-align: center;">No products found for "${query}"</div>`;
          } else {
            dropdown.innerHTML = prods
              .map((p) => {
                let priceText = "";
                if (p.price != null) {
                  let num = parseFloat(p.price);
                  if (!isNaN(num)) {
                    if (typeof p.price === 'number' && num > 500 && Number.isInteger(num)) {
                      priceText = "$" + (num / 100).toFixed(2) + " CAD";
                    } else {
                      priceText = "$" + num.toFixed(2) + " CAD";
                    }
                  } else {
                    priceText = String(p.price);
                  }
                }
                const imgUrl = p.image || p.featured_image?.url || "";
                return `
                  <a href="${p.url}" style="display: flex; align-items: center; gap: 12px; padding: 10px 14px; border-bottom: 1px solid #f1f5f9; text-decoration: none;">
                    ${imgUrl ? `<img src="${imgUrl}" alt="${p.title}" style="width: 44px; height: 44px; object-fit: contain; border-radius: 6px; border: 1px solid #e2e8f0; background: #fff;">` : ''}
                    <div style="flex: 1; min-width: 0;">
                      <div style="font-size: 13px; font-weight: 600; color: #0f172a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${p.title}</div>
                      ${priceText ? `<div style="font-size: 12px; color: #c89658; font-weight: 700;">${priceText}</div>` : ''}
                    </div>
                  </a>
                `;
              })
              .join("") + `
                <a href="/search?q=${encodeURIComponent(query)}" style="display: block; text-align: center; padding: 10px; font-size: 12px; font-weight: 600; color: #c89658; background: #f8fafc; border-radius: 0 0 12px 12px; text-decoration: none;">View all results for "${query}" →</a>
              `;
          }
          dropdown.style.display = "block";
        })
        .catch((err) => {
          console.warn("Search error:", err);
          dropdown.style.display = "none";
        });
    }, 200);
  });

  document.addEventListener("click", (e) => {
    if (!searchInput.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.style.display = "none";
    }
  });
}

// --------------------------------------------------------------------------
// 6. GLOBAL HELPERS
// --------------------------------------------------------------------------
function toggleWishlist(id, btn) {
  btn.classList.toggle("active");
  const svg = btn.querySelector("svg");
  if (btn.classList.contains("active")) {
    svg.style.fill = "#e11d48";
    svg.style.stroke = "#e11d48";
  } else {
    svg.style.fill = "none";
    svg.style.stroke = "currentColor";
  }
}


// --------------------------------------------------------------------------
// 7. MOBILE NAVIGATION DRAWER
// --------------------------------------------------------------------------
function initMobileNav() {
  const openBtn = document.getElementById("openMobileMenuBtn");
  const closeBtn = document.getElementById("closeMobileMenuBtn");
  const overlay = document.getElementById("mobileNavOverlay");
  const drawer = document.getElementById("mobileNavDrawer");

  function openMenu() {
    if (drawer) drawer.classList.add("active");
    if (overlay) overlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeMenu() {
    if (drawer) drawer.classList.remove("active");
    if (overlay) overlay.classList.remove("active");
    document.body.style.overflow = "";
  }

  if (openBtn) openBtn.addEventListener("click", openMenu);
  if (closeBtn) closeBtn.addEventListener("click", closeMenu);
  if (overlay) overlay.addEventListener("click", closeMenu);
}
